import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23266 33820"
    {...props}
  >
    <path
      d="M3831 0h15261c1469 0 2533 227 3189 688 657 453 985 1212 985 2267 0 623-362 1439-1094 2454h-6094l11-14H3831c-1290 0-2244-235-2877-704C321 4229 0 3495 0 2502 0 1447 336 766 1009 461 1681 156 2619 0 3831 0zm14261 10949c-547 839-1102 1767-1666 2787-1048 1892-2010 4206-2877 6942-368 1204-626 2205-782 2995-149 797-321 1829-500 3096-188 1266-344 2236-485 2908-321 1555-774 2635-1360 3236-595 602-1377 907-2354 907-930 0-1681-321-2244-969-570-649-852-1611-852-2877 0-978 211-2306 618-3979 414-1681 1087-3691 2017-6036 938-2337 2103-4746 3502-7208 340-601 696-1202 1068-1802h5915z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
